import type {
  StepVisibilityCondition,
  StepVisibilityConditionGroup,
  StepVisibilitySingleCondition,
} from '../types/formBuilder';

function isGroupCondition(
  condition: StepVisibilityCondition | undefined,
): condition is StepVisibilityConditionGroup {
  return !!condition && Array.isArray((condition as StepVisibilityConditionGroup).conditions);
}

function normalizeComparable(value: unknown) {
  if (value instanceof Date) return value.getTime();
  return value;
}

function evaluateSingleCondition(
  condition: StepVisibilitySingleCondition,
  formData: Record<string, unknown>,
) {
  const fieldValue = normalizeComparable(formData[condition.fieldKey]);
  const compareValue = normalizeComparable(condition.value);

  switch (condition.operator) {
    case 'EQUALS':
      return fieldValue === compareValue;
    case 'NOT_EQUALS':
      return fieldValue !== compareValue;
    case 'IN': {
      const values = Array.isArray(compareValue) ? compareValue : [compareValue];
      return values.includes(fieldValue);
    }
    case 'GREATER_THAN':
      return Number(fieldValue) > Number(compareValue);
    case 'EXISTS':
      return fieldValue !== null && fieldValue !== undefined;
    default:
      return true;
  }
}

export function evaluateVisibilityCondition(
  condition: StepVisibilityCondition | undefined,
  formData: Record<string, unknown>,
): boolean {
  if (!condition) return true;

  if (isGroupCondition(condition)) {
    const conditions = condition.conditions ?? [];
    if (conditions.length === 0) return true;
    const evaluator = (item: StepVisibilityCondition) =>
      evaluateVisibilityCondition(item, formData);
    return condition.logic === 'OR' ? conditions.some(evaluator) : conditions.every(evaluator);
  }

  return evaluateSingleCondition(condition, formData);
}

export const evaluateStepVisibilityCondition = evaluateVisibilityCondition;